module.exports = __webpack_public_path__ + "static/card5-64b8990e859733294c5f7cb11715dfff.png";